module.exports = __webpack_public_path__ + "static/media/22x28no3.35f38906.jpg";